import { useEffect, useState } from "react";
import "./OurPackagesPageCss/CompareModal.css";
import { IoMdHelpCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { getCompareList } from "../../api/api";
import { getUserData } from "../../utils/auth";

const CompareModal = ({ compareList, onClose , onBookNow }) => {
  const [filterType, setFilterType] = useState("all");
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [packageId, setPackageId] = useState([]);
  const [combinedPackages, setCombinedPackages] = useState([]);

  const navigator = useNavigate();

  // Extract service ids
  useEffect(() => {
    if (compareList.length > 0) {
      const ids = compareList.map((pkg) => pkg?.service_id);
      setPackageId(ids);
    }
  }, [compareList]);

  // Fetch API data when packageId changes
  useEffect(() => {
    if (packageId && packageId.length > 0) {
      fetchCompareList();
    }
  }, [packageId]);

  const fetchCompareList = async () => {
    const payload = { id: packageId };
    try {
      const response = await getCompareList(payload);
      console.log("Fetched compare list:", response);

      // grab stored user name (if available) to show in header
      const stored = getUserData();
      const storedName = stored?.data?.PFirstName
        ? `${stored.data.PFirstName} ${stored.data.PLastName || ""}`.trim()
        : stored?.data?.name || "";

      // Attach API test lists to original compareList packages
      const mergedPackages = compareList.map((pkg, index) => {
        let list = [];
        if (index === 0) list = response?.data?.p_list_1 || [];
        if (index === 1) list = response?.data?.p_list_2 || [];
        if (index === 2) list = response?.data?.p_list_3 || [];

        return {
          ...pkg,
          list,
          // prefer an explicitly provided memberName on the pkg, otherwise use logged-in profile name
          memberName: pkg?.memberName || storedName || "",
        };
      });

      setCombinedPackages(mergedPackages);
    } catch (error) {
      console.error("Error fetching compare list:", error);
    }
  };

  ///// Collect all unique test names from all packages
  const allTests = [
    ...new Set(
      combinedPackages.flatMap((pkg) =>
        pkg.list.map((t) => t.Test_name || t.service_name)
      )
    ),
  ];

  ///// Filter uncommon tests
  const filteredTests = allTests.filter((testName) => {
    const includedCount = combinedPackages.filter((pkg) =>
      pkg.list.some((t) => (t.Test_name || t.service_name) === testName)
    ).length;

    return filterType === "all" || includedCount < combinedPackages.length;
  });

  // Common tests (present in all packages)
  const commonTests = allTests.filter((testName) => {
    const includedCount = combinedPackages.filter((pkg) =>
      pkg.list.some((t) => (t.Test_name || t.service_name) === testName)
    ).length;

    return includedCount === combinedPackages.length;
  });

  return (
    <div className="compareModalBackdrop">
      <div className="compareModal">
        <button className="closeBtn" onClick={onClose}>
          X
        </button>

        {/* Filter Buttons */}
        <div className="filterButtonsContainer">
          <h4 style={{ marginRight: "0.5rem" }}>Filter By</h4>
          <button
            className={filterType === "all" ? "activeFilterBtn" : ""}
            onClick={() => setFilterType("all")}
          >
            All Tests
          </button>
          <button
            className={filterType === "uncommon" ? "activeFilterBtn" : ""}
            onClick={() => setFilterType("uncommon")}
          >
            Uncommon Tests
          </button>
          <div
            className="helpIcon"
            onClick={() => setShowHelpModal(true)}
            title="Help?"
          >
            <IoMdHelpCircle size={30} style={{ cursor: "pointer" }} />
          </div>
        </div>

        {/* Comparison Table */}
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Test Name</th>
              {combinedPackages.map((pkg, i) => (
                <th key={i}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: 600 }}>{pkg.service_name}</span>
                    {pkg?.memberName && (
                      <small style={{ color: "#666" }}>{pkg.memberName}</small>
                    )}
                    <span style={{ marginTop: 6 }}>₹{pkg?.price}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredTests.map((test, i) => (
              <tr key={i}>
                <td>{test}</td>
                {combinedPackages.map((pkg) => {
                  const hasTest = pkg.list.some(
                    (t) => (t.Test_name || t.service_name) === test
                  );
                  return (
                    <td key={`${pkg.service_id}-${test}`}>
                      {hasTest ? "✔" : "✖"}
                    </td>
                  );
                })}
              </tr>
            ))}
          {filterType === "uncommon" && (
            <>
            <tr>
              <td
                colSpan={combinedPackages.length + 1}
                style={{
                  fontWeight: "600",
                  textAlign: "center",
                  background: "#f2f2f2",
                }}
              >
                Common Tests
              </td>
            </tr>

            {commonTests.map((test, i) => (
              <tr key={`common-${i}`}>
                <td>{test}</td>
                {combinedPackages.map((pkg) => (
                  <td key={`${pkg.service_id}-${test}`}>✔</td>
                ))}
              </tr>
            ))}
            </>
          )}

            {/* Row for Book Now Buttons */}
            <tr>
              <td>Book Selected Package</td>
              {combinedPackages.map((pkg, i) => (
                <td key={`book-${i}`}>
                  <button
                    className="rbdButton bookNowBtn"
                   
                    onClick={() => onBookNow(pkg)}
                  >
                    <span className="btn-text">Book Now</span>
                  </button>
                </td>
              ))}
            </tr>
          </tbody>
        </table>

        {/* Help Popup */}
        {showHelpModal && (
          <div className="helpPopupBackdrop">
            <div className="helpPopup">
              <button
                className="closeBtn"
                onClick={() => setShowHelpModal(false)}
              >
                X
              </button>
              <h3>What is "Uncommon Test"?</h3>
              <p>
                By selecting the <strong>"Uncommon Tests"</strong> filter you
                will see only the tests which are not common across all selected
                packages.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompareModal;
